import { useController } from '../../hooks/useController'

import { VerizonConnect } from './components/VerizonConnect'
import { Linxup } from './components/Linxup'
import { Azuga } from './components/Azuga'
import { Geotab } from './components/Geotab'

export function Header() {
  const {
    close,
    data: { source, tenantSource },
  } = useController()

  if (!source) return null

  switch (source.label) {
    case 'Azuga':
      return <Azuga source={source} tenantSource={tenantSource} close={close} />

    case 'Linxup':
      return <Linxup source={source} tenantSource={tenantSource} close={close} />

    case 'Geotab':
      return <Geotab source={source} tenantSource={tenantSource} close={close} />

    case 'Verizon Connect':
    case 'Verizon Connect (EU)':
    case 'Verizon Connect (US)':
      return <VerizonConnect source={source} tenantSource={tenantSource} close={close} />

    default:
      return null
  }
}
